import React from 'react';

import { useTranslation } from 'react-i18next';

import IndividualDocumentAppend from '~/features/leadDetails/components/Overview/DocumentCenter/Demands/Documents/Individual/IndividualDocumentAppend';
import IndividualDocumentEntry from '~/features/leadDetails/components/Overview/DocumentCenter/Demands/Documents/Individual/IndividualDocumentEntry';
import type {
    SchemaDemandedDocumentEntry,
    SchemaDemandedDocumentsKeys,
} from '~/features/leadDetails/schemas/demandedDocuments.schema';

type Props = {
    documents: SchemaDemandedDocumentEntry[];
    update: (path: SchemaDemandedDocumentsKeys, name: string, requested: boolean) => void;
    remove: (path: SchemaDemandedDocumentsKeys, name: string) => void;
};

const IndividualCategory: React.FC<Props> = ({ documents, remove, update }) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col gap-3 rounded-md border border-grey-stroke bg-surface-light px-4 py-3">
            <p className="text-sm font-medium text-midnight">{t('DOCUMENT_DEMANDER.CATEGORIES.INDIVIDUAL_DOCUMENT')}</p>
            <div className="flex flex-col gap-2">
                {documents.map(({ name, requested }) => (
                    <IndividualDocumentEntry
                        key={name}
                        document={name}
                        requested={requested}
                        update={update}
                        remove={remove}
                    />
                ))}
                <IndividualDocumentAppend update={update} />
            </div>
        </div>
    );
};

export default IndividualCategory;
